import { ApiClient } from "./apiClient";
import { ApiResponse } from "./types";
import {appConfig} from "../config";


export interface LeaveType {
    id: number;
    name: string;
    displayText: string;
    calendarColor: string;
    createdAt: string;
    updatedAt: string;
}

export type CreateLeaveTypeRequest = Omit<LeaveType, 'id' | 'createdAt' | 'updatedAt'>;

export type UpdateLeaveTypeRequest = Partial<CreateLeaveTypeRequest>;

const apiClient = new ApiClient(`${appConfig.backendUrl}/api/leave-types`);

export const fetchLeaveTypes = (): Promise<ApiResponse<LeaveType[]>> => {
    return apiClient.get<LeaveType[]>();
};

export const createLeaveType = (leaveTypeData: CreateLeaveTypeRequest): Promise<ApiResponse<LeaveType>> => {
    return apiClient.post<LeaveType>('', leaveTypeData);
};

export const updateLeaveType = (id: number, leaveTypeData: UpdateLeaveTypeRequest): Promise<ApiResponse<LeaveType>> => {
    return apiClient.put<LeaveType>(`/${id}`, leaveTypeData);
};

export const deleteLeaveType = (id: number): Promise<ApiResponse<void>> => {
    return apiClient.delete<void>(`/${id}`);
};